import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CommerceBppSettingDetailPopup } from "./commerce-bpp-setting-popup";
import Table from "../../../../../../common/components/table-manager/v1.1/table";

const CommerceBppSettings = () => {
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const [showRejectionPopup, setShowRejectionPopup] = useState<boolean>();
    const [itemDetails, setItemDetails] = useState<any>();

    const [selectedProductCockpitRejections, setSelectedProductCockpitRejections] = useState<any>();
    const { state } = useLocation();
    console.log('state', state)
    const [columnDefs, setColumnDefs] = useState({});

    const configurations = [
        {
            Id: 1,
            tenant: 'dbs',
            bpp_id: 'bpp.dbs.digiit.ai',
            IsDebuggingEnabled: true,
            level: 'info',
            status: 'Active'
        },
        {
            Id: 2,
            tenant: 'agri',
            bpp_id: 'bpp.agri.digiit.ai',
            IsDebuggingEnabled: true,
            level: 'info',
            status: 'Active'
        }
    ]

    useEffect(() => {
        setSelectedProductCockpitRejections(state)
    }, [state]);

    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'tenant', headerName: 'Tenant', sortable: true, filter: true, filterType: 'text' },
            { field: 'bpp_id', headerName: 'BPP ID', sortable: true, filter: true, filterType: 'text' },
            { field: 'IsDebuggingEnabled', headerName: 'Debugging Enabled', cellRenderer: 'yesNoRenderer', filter: true, filterType: 'boolean', sortable: false },
            { field: 'level', headerName: 'Log Level', sortable: true, filter: true, filterType: 'text'},
            { field: 'status', headerName: 'Status', sortable: true, filter: true, filterType: 'text'},
        ]);
    }

    
    // const handleEditProduct = (data: any) => {
    //     console.log('product data', data)
    //     window.open(`/management/catalog/products/${selectedProductCockpitRejections?.productId}`, '_blank');

    // }


    // const customFunctions = [
    //     {icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
    //         <path d="M11.0991 3.00012C7.45013 3.00669 5.53932 3.09629 4.31817 4.31764C3.00034 5.63568 3.00034 7.75704 3.00034 11.9997C3.00034 16.2424 3.00034 18.3638 4.31817 19.6818C5.63599 20.9999 7.75701 20.9999 11.9991 20.9999C16.241 20.9999 18.3621 20.9999 19.6799 19.6818C20.901 18.4605 20.9906 16.5493 20.9972 12.8998" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    //         <path d="M20.556 3.49612L11.0487 13.0586M20.556 3.49612C20.062 3.00151 16.7343 3.04761 16.0308 3.05762M20.556 3.49612C21.05 3.99074 21.0039 7.32273 20.9939 8.02714" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    //     </svg>, callback: handleEditProduct, title: "Show Specification Attribute Items"},
    //     // {icon: <MdTableView className="text-gray-800 text-xl" />, callback: handleSpecificationAttributeOptions, title: "Show Specification Attribute Options"},
    //   ];

    const handleViewList = (itemDetails: any) => {
        // console.log('itemDetails', itemDetails)
        // setItemDetails(itemDetails)
        // setShowRejectionPopup(true)
    }

    const handleEdit = (data: any) => {
        console.log('data', data)
        navigate(`/gateway/settings/commerce/bpp/${data.Id}`,{ state: {data: data}})
    }

    const handleDelete = (data: any) => {

    }

    const back = () => {
        navigate(-1)
    }

    const closeModal = () => {
        setShowRejectionPopup(false)
    }


    useEffect(() => {
        createColumnDefs()
    }, []
    )

    return (
        <>
            {
                showRejectionPopup ?
                    <CommerceBppSettingDetailPopup
                        closeModal={closeModal}
                        item={itemDetails}
                    /> : <></>
            }
            {/* <div className="p-4 text-xl font-bold">
                {`ID: ${selectedProductCockpitRejections?.productId} - Combination ID: ${selectedProductCockpitRejections?.id} - Name: ${selectedProductCockpitRejections?.name}`}
            </div> */}
            <Table
                columnData={columnDefs}
                rowData={configurations}
                enableFilter={true} 
                // customFunctions={customFunctions}
                // onViewList={handleViewList}
                onEdit={handleEdit}
                onDelete={handleDelete}
                checkboxConfig={{
                    allowMultiSelect: true,
                    defaultSelectedIds: [],
                    isDisabled: false,
                    keyColumn: 'Id',
                }}
                headingName="BPP Settings"
            />
            {/* <div className="flex justify-end mt-6">
                <button
                    onClick={back}
                    type="button"
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
                >
                    Back
                </button>
            </div> */}
        </>
    )
};

export default CommerceBppSettings;


